<script setup lang="ts">
const { story, blok } = await useStoryblokContent({
  resolve_relations: [
    "blog-main.featuredPostsList",
    "blog-main.featuredPostsWidget",
    "blog-main.slideshow",
    "banner-slideshow.banners",
    "blog-main.featuredGuidesList",
    "featured-guides-list.guides",
    "blog-main.featuredRubrics",
    "blog-main.toolList",
    "tool-list.tools",
  ],
});
const categories = await getCategories();
</script>

<template>
  <div class="page-container">
    <BlogSearchHeader />
    <StoryblokComponent v-bind="{ blok, story, categories }" />
  </div>
</template>
